import { applyFallbackColorSettings, applyFallbackIds } from '../helpers/settingsReducerHelpers';

const initialState = {
  settings: {
    widgets: [],
    settings: {},
  },
  error: null,
};

function settingsReducer(state = initialState, action) {
  if (action.type === 'SETTINGS_UPDATE') {
    const settingsNoFallback = {
      ...state.settings,
      ...action.data,
    };

    const settings = {
      ...settingsNoFallback,
      settings: applyFallbackColorSettings(settingsNoFallback.settings),
      widgets: applyFallbackIds(settingsNoFallback.widgets),
    };

    return {
      ...state,
      settings,
      error: null,
    };
  }

  if (action.type === 'SETTINGS_ERROR') {
    return {
      ...state,
      error: action.error,
    };
  }

  return state;
}

export default settingsReducer;
